import { render, staticRenderFns } from "./Cuori.vue?vue&type=template&id=c2d52000&scoped=true&"
import script from "./Cuori.vue?vue&type=script&lang=js&"
export * from "./Cuori.vue?vue&type=script&lang=js&"
import style0 from "./Cuori.vue?vue&type=style&index=0&id=c2d52000&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2d52000",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2d52000')) {
      api.createRecord('c2d52000', component.options)
    } else {
      api.reload('c2d52000', component.options)
    }
    module.hot.accept("./Cuori.vue?vue&type=template&id=c2d52000&scoped=true&", function () {
      api.rerender('c2d52000', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/Cuori.vue"
export default component.exports